/**
 * FormCell Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

interface IFormCellProps {
  conditionalDisplay?: boolean;
  minimumWidth?: number | 'full';
  noMarginLeft?: boolean;
  spacer?: boolean;
}

const classes = new BEM('form__cell');

export default class FormCell extends React.Component<IFormCellProps, {}> {
  render() {
    const { minimumWidth, children } = this.props;
    const modifiers = {
      'no-margin-left': !!this.props.noMarginLeft,
      'is-spacer': !!this.props.spacer,
    };
    return !this.shouldRender() ? null : (
      <div {...classes('', modifiers) } data-min-width={minimumWidth}>{children}</div>
    );
  }

  private shouldRender() {
    return this.props.conditionalDisplay === true || this.props.conditionalDisplay == null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/FormCell/index.tsx